import { FormFieldConfig } from '../FormGenerator/FormGenerator';
import { DetailedListColumn } from './DetailedListComponent';

// Example: You can extend this per-entity or per-table as needed
export const getFormFieldsFromColumns = (columns: DetailedListColumn<any>[]): FormFieldConfig[] => {
  return columns.map(col => {
    let type: 'string' | 'number' | 'select' | 'checkbox' | 'multiline' | 'date' = 'string';
    if (col.type) type = col.type;
    else if (col.key.toLowerCase().includes('id')) type = 'number';
    else if (col.key.toLowerCase().includes('count') || col.key.toLowerCase().includes('number')) type = 'number';
    // Enum support: if options are present, treat as select
    if (col.options && col.options.length > 0) type = 'select';
    // Multiline support
    if (col.multiline) type = 'multiline';
    return {
      key: col.key,
      label: col.header,
      type,
      required: (col as any).required === true, // propagate required if present
      options: col.options, // pass options for select fields
      multiline: col.multiline,
      rows: col.rows,
    };
  });
};
